import { Component, ElementRef, inject, signal, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentOcrService } from './document-ocr.service';

@Component({
  selector: 'app-ocr-capture',
  standalone: true,
  imports: [],
  templateUrl: './ocr-capture.component.html',
  styleUrl: './ocr-capture.component.scss',
})
export class OcrCaptureComponent {
  private readonly ocr = inject(DocumentOcrService);
  private readonly router = inject(Router);
  private readonly fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');

  readonly message = signal<string | null>(null);
  readonly error = signal<string | null>(null);
  readonly uploading = signal(false);
  readonly dragOver = signal(false);

  openFilePicker(): void {
    this.fileInput()?.nativeElement.click();
  }

  onFiles(list: FileList | null): void {
    if (!list?.length) return;
    const file = list.item(0);
    if (!file) return;
    void this.upload(file);
  }

  onDrop(ev: DragEvent): void {
    ev.preventDefault();
    this.dragOver.set(false);
    this.onFiles(ev.dataTransfer?.files ?? null);
  }

  private async upload(file: File): Promise<void> {
    this.error.set(null);
    this.message.set(null);
    this.uploading.set(true);
    try {
      await this.ocr.upload(file);
      this.message.set(`Uploaded ${file.name} — extraction is running in the background.`);
      void this.router.navigate(['/document-ocr', 'documents']);
    } catch (err) {
      this.error.set(err instanceof Error ? err.message : 'Upload failed');
    } finally {
      this.uploading.set(false);
    }
  }
}
